import LoginDialog from "@/components/LoginModal";
import { BASE_URL } from "@/constants/apiConfig";
import oauth2Client from "@/utils/auth";
import { openWindow } from "@/utils/open";
import { tokenFieldName, uidFieldName } from "@/utils/uid";
import axios from "axios";
import Cookies from "js-cookie";
import qs from "qs";
import request from "../utils/request";

/**
 * 登录接口
 * @param {{
 *  email: string;
 *  password: string;
 *  agree_protocol?: boolean;
 *  login_code?: string;
 * }} param0
 * @returns
 */
export async function login({
  email,
  password,
  agree_protocol,
  login_code,
} = {}) {
  return request({
    method: "post",
    url: "/auth/",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    transformRequest: [qs.stringify],
    ignoreMessage: true,
    ignoreVerify: true,
    data: {
      email,
      password,
      agree_protocol,
      login_code,
    },
  }).catch(() => {
    return {};
  });
}

export async function getMe(cookie) {
  return request({
    url: "/users/me",
    ignoreMessage: true,
    ...(cookie
      ? {
          headers: {
            cookie,
          },
        }
      : {}),
  });
}

export async function logout(isSync = true) {
  if (isSync) {
    await oauth2Client.logoutSync();
  } else {
    await oauth2Client.logout();
  }

  // 手动删一下token
  Cookies.remove(tokenFieldName, {
    domain: ".huaban.com",
    path: "/",
  });

  return request({
    url: "/logout",
    ignoreMessage: true,
  })
    .then(() => {
      // 退出登录后删除用户信息，避免埋点数据影响
      Cookies.remove(uidFieldName, {
        domain: ".huaban.com",
        path: "/",
      });
      Cookies.remove("gd_id", {
        domain: ".huaban.com",
        path: "/",
      });
    })
    .catch(() => {
      // ignore
    });
}
/**
 * 频繁登录key
 * @param {*} param0
 * @returns
 */
export async function verify({ key, csessionid, value, sig, token }) {
  return request({
    method: "post",
    url: "/captcha/rater",
    data: {
      key: key,
      type: "limit",
      validate: {
        csessionid: csessionid,
        value: value,
        sig: sig,
        token: token,
        scene: "other",
      },
    },
  });
}

export async function resetVerify({ tel, email, validate }) {
  return request({
    method: "post",
    url: `/password/reset/${email ? "email" : "tel"}`,
    data: {
      tel,
      validate,
      email,
    },
    ignoreError: true,
  }).catch((err) => {
    if (err.response.data) {
      return err.response.data;
    } else {
      throw err;
    }
  });
}

export async function resetPwd({
  tel,
  email,
  captcha,
  password1,
  password2,
  token,
}) {
  return request({
    method: "post",
    url: "/password/reset",
    data: { tel, email, captcha, password1, password2, token },
    ignoreError: true,
  }).catch((err) => {
    if (err.response.data) {
      return err.response.data;
    } else {
      throw err;
    }
  });
}

export async function registerVerify({ tel, validate }) {
  return request({
    method: "post",
    url: "/signup/tel",
    data: {
      tel,
      validate,
    },
  });
}

export async function register({
  tel,
  username,
  captcha,
  password,
  password_confirm,
  job,
  job_id,
}) {
  return request({
    method: "post",
    url: "/signup",
    data: { tel, username, captcha, password, password_confirm, job, job_id },
    ignoreMessage: true,
    ignoreError: true,
  }).catch((err) => {
    if (err.response.data) {
      return err.response.data;
    } else {
      throw err;
    }
  });
}
/**
 * 验证码类型
 */
export const SEND_SMS_REASON = {
  /** 密码重置 */
  resendResetPassword: "resetPassword",
  /** 注册时手机验证 */
  signupStep2: "signupStep2",
  /** 绑定手机 */
  bindHuaban: "bindHuaban",
  /** 绑定新手机号 */
  bindNewTel: "bindNewTel",
  /** 认证设计师验证码 */
  realAuth: "realAuth",
};

/**
 * 发送验证码
 * @param {{
 *  reason: string,
 *  tel: string,
 *  validate?: string
 * }} param0
 * @returns
 */
export async function sendSms({ reason, tel, validate }) {
  return request({
    method: "post",
    url: "/captcha",
    data: {
      reason,
      tel,
      validate,
    },
  });
}

/**
 * 第三方登录接口
 * @param {type} 第三方类型 wechat douban qzone weibo
 */
export async function thirdLogin(type) {
  // const unifiedLoginAb = await getExpsValue(
  //   AB_LOGIN.variableName,
  //   AB_LOGIN.defaultValue
  // );

  // if (unifiedLoginAb === "string_1") {
  return LoginDialog.open({
    target: "blank",
    source_location: "第三方登录",
  });

  // if (window.location.pathname === "/") {
  //   href = href + "follow";
  // }
  // a.target = "_blank";
  // a.href = BASE_URL + `/oauth/${type}/login/?auth_callback=${href}`;
  // a.click();

  // 关闭其他第三方登录窗口
  // if (window.__login_window) {
  //   window.__login_window.close();
  // }

  // window.__login_window = openWindow({
  //   clientWidth: 770,
  //   clientHeight: 573,
  //   url:
  //     BASE_URL +
  //     `/oauth/${type}/login/?auth_callback=${encodeURIComponent(href)}`,
  //   windowName: "第三方登录注册",
  // });
}

/**
 * 第三方绑定接口
 * @param {type} 第三方类型 wechat douban qzone weibo
 */
export async function thirdBind(type) {
  let href = window.location.href;

  // 关闭其他第三方登录窗口
  if (window.__login_window) {
    window.__login_window.close();
  }

  window.__login_window = openWindow({
    clientWidth: 770,
    clientHeight: 573,
    url:
      BASE_URL +
      `/oauth/${type}/binding/?auth_callback=${encodeURIComponent(href)}`,
    windowName: "第三方账号绑定",
  });
}

/**
 * 第三方登录回调，重定向到登录具体页面
 * @param {string} code 登录code
 * @param {string} state 登录state
 */
export async function authCallback(code, state) {
  // const a = document.createElement("a");
  // a.href = BASE_URL + `/oauth/callback?code=${code}&state=${state}`;
  // a.click();

  return request({
    method: "get",
    url: `/oauth/callback?code=${code}&state=${state}`,
    // 返回响应对象，方便做一些判断处理
    returnRes: true,
  });
}

/**
 * 账号申诉
 * @param {Object} props
 * @param {string} props.username 用户名
 * @param {string} props.url 个性网址
 */
export async function appeal({ username, url }) {
  return request({
    method: "post",
    url: "/appeal",
    data: {
      username,
      url,
    },
  });
}

/**
 * 获取申诉信息，自动代入申诉表单中
 */
export async function getAppealInfo() {
  return request({
    method: "get",
    url: "/appeal",
  });
}

export async function getWxQrcode() {
  return request({
    method: "post",
    url: "/wechat/qrcode",
  });
}

export async function getWxLoginRes(scene_str) {
  return request({
    url: "/wechat/qrcode/check",
    query: {
      scene_str,
    },
  });
}

// 微信扫码后注册
export async function getSignup() {
  return request({
    url: "/signup",
    ignoreError: true,
    ignoreMessage: true,
  });
}
// 判断是否关注服务号
export async function getOfficialAccounts(scene_str) {
  return request({
    url: "/users/me/bindingrecords",
    query: {
      scene_str,
    },
    // baseURL:'https://yapi.gaoding.com/mock/1536'
  });
}

/**
 *  获取第三方授权信息
 * @returns {Promise<*>}
 */
export function getOAuth({ response_type, client_id, redirect_uri }) {
  return request({
    url: "/oauth/authorize",
    query: {
      response_type,
      client_id,
      redirect_uri,
    },
  });
}

/**
 *  获取第三方授权信息
 * @returns {Promise<*>}
 */
export function sendOAuth({
  response_type,
  client_id,
  redirect_uri,
  action,
  accept,
}) {
  return request({
    url: "/oauth/authorize",
    method: "post",
    data: {
      response_type,
      client_id,
      redirect_uri,
      action,
      accept,
    },
  });
}

/**
 * 退出其他设备
 */
export function logoutOtherDevices() {
  return request({
    method: "post",
    url: "/logout/devices",
  });
}

export function getPhoneInfo(tel) {
  return request({
    method: "post",
    url: "/users/tel/binding",
    data: {
      tel,
    },
  });
}

// 获取用户udesk签名
export function getUdeskSign() {
  return request({
    method: "get",
    url: "/udesk/sign",
  });
}

export function getTelAreaCodes() {
  return axios({
    method: "get",
    url: "https://cdn.dancf.com/auth/assets/area-code/zh/code.json",
  });
}

/**
 * session登录用户，session换token
 * https://yapi.gaoding.com/project/20/interface/api/211000
 * @param {string} redirect_uri 重定向地址
 */
export function sessionExchangeRedirect(redirect_uri) {
  window.open(
    `/ums/cgi/huaban/session-exchange-redirect?redirect_uri=${encodeURIComponent(
      redirect_uri
    )}`
  );
}
